export const EVENT_START_HOUR = 19;
export const EVENT_LENGTH_MINUTES = 360;
export const LIVE_FROM = 260;

function pad(value: number): string {
  return String(value).padStart(2, "0");
}

export function nowAt(startedAt: number, now: number): number {
  const elapsed = Math.max(0, Math.floor((now - startedAt) / 60_000));
  return Math.min(LIVE_FROM + elapsed, EVENT_LENGTH_MINUTES - 1);
}

export function hourOf(at: number): number {
  return (EVENT_START_HOUR + Math.floor(at / 60)) % 24;
}

export function clockLabel(at: number): string {
  return `${hourOf(at)}h${pad(at % 60)}`;
}

export function wallTime(at: number): string {
  return `${pad(hourOf(at))}:${pad(at % 60)}`;
}

export function remainingMinutes(current: number): number {
  return Math.max(0, EVENT_LENGTH_MINUTES - current);
}

export function ringLabel(remaining: number): string {
  return remaining < 60 ? `${remaining}m` : `${Math.floor(remaining / 60)}h${pad(remaining % 60)}`;
}

export function durationLabel(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  return hours > 0 ? `${hours}h ${minutes % 60}m` : `${minutes}m`;
}

export function sinceLabel(at: number, current: number): string {
  const minutes = current - at;
  if (minutes < 1) {
    return "Agora mesmo";
  }
  const format = new Intl.RelativeTimeFormat("pt-BR", { numeric: "always" });
  return minutes < 60
    ? format.format(-minutes, "minute")
    : format.format(-Math.floor(minutes / 60), "hour");
}

export function dayLabel(date: Date): string {
  const weekday = new Intl.DateTimeFormat("pt-BR", { weekday: "short" })
    .format(date)
    .replace(".", "");
  const month = new Intl.DateTimeFormat("pt-BR", { month: "short" }).format(date).replace(".", "");
  return `${weekday}, ${date.getDate()} ${month}`;
}
